export default __webpack_public_path__ + "97922036b1e0524663b2ff6738b6ae87.png";